import * as Sentry from "@sentry/nextjs";
import { sentryShared } from "./sentry.shared";

// Client-side Sentry init (browser). Captures unhandled client errors + the
// React error boundaries' captureException calls. No Session Replay (PII).
Sentry.init({ ...sentryShared });

// Required by @sentry/nextjs for App Router navigation instrumentation.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
